import Tabs from '@material-ui/core/Tabs';
import useStyles from './styles';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useOrderFilterActions,
  useOrderFilterState,
} from '../../context/order-filter';
import { OrderStatus } from '../../context/orders';
import JetButton from '@src/shared/components/JetButton';
import { trackDeliveryDashboardOrderFilterSelections } from '../../tracking/delivery-dashboard';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import i18n from '@src/i18n';


interface IOrderFilterProps {
  children: React.ReactNode,
}

export const OrderFilterWrapper:FC<React.ReactNode> = ({children}) => {
  const classes = useStyles();
  return (
    <div className={classes.orderFilterItemContent}>
      {children}
    </div>
  )
}

export const OrderFilter: FC<IOrderFilterProps> = ({ children }) => {
  const classes = useStyles();
  const { setOrderFilter, flushOrderFilter } = useOrderFilterActions();
  const { activeOrderFilter} = useOrderFilterState();  
  const [filterElements, setFilterElements] = useState<OrderStatus[]>([]);
  const { t } = useTranslation();
  const { restaurant } = useKeycloakUserState();
  const decouplingElements = () => {
    return activeOrderFilter.map(items => items).join(',')
   }
  
     useEffect(() => {
      trackDeliveryDashboardOrderFilterSelections({
        component_name: 'today orders',
        country: restaurant?.country,
        language: i18n.language,
        list_countsTotals: children && children['props'].children.length || 0,
        list_filter: decouplingElements() || 'All',
    })
   },[activeOrderFilter])
  
  const handleFilterElements = (selectedFilter: OrderStatus | 'All') => {
    if (selectedFilter === 'All') {
      flushOrderFilter();
      setFilterElements([]);
    } else {
      if (filterElements.includes(selectedFilter)) {
        const toggleFilterelements = filterElements.filter(
          (item) => item !== selectedFilter
        );
        setFilterElements([...toggleFilterelements]);
      } else {
        setFilterElements([...activeOrderFilter, selectedFilter]);
      }
    }
  };

  useEffect(() => {
    if (filterElements.length > 0) {
      setOrderFilter(filterElements);
    }
    return () => {
      flushOrderFilter();
    };
  }, [filterElements]);
  return (
    <>
      <div className={classes.ordeFilterWrapper}>
        <Tabs
          classes={{
            root: classes.orderFilterTabs,
            scrollButtons: classes.orderFilterScrollButtons,
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="desktop"
          value={false}
          /*w      ScrollButtonComponent={(props) => {
          console.log('Props',props)
         if(!props.disabled) {
            return  <div className={classes.orderFilterScrollButtons}><JetFontIcon {...props} iconname={ props.direction === 'right' ? JET_FONTICON_ALIASES.CHEVRON_RIGHT : JET_FONTICON_ALIASES.CHEVRON_LEFT} size={16} /> </div>
         }  {
          return null;
         }
          
        }} */
        >
          <OrderFilterWrapper>
            <JetButton
              value={null}
              className={classes.orderFilterButton}
              onClick={() => {
                activeOrderFilter.length > 0
                  ? handleFilterElements('All')
                  : null;
              }}
              variation={`${
                activeOrderFilter.length === 0 ? 'primary' : 'default'
              }`}
              size="xsmall"
            >
              {t('order.filter_all')}
            </JetButton>

            <JetButton
              value={OrderStatus.Assigned}
              className={classes.orderFilterButton}
              onClick={() => handleFilterElements(OrderStatus.Assigned)}
              variation={`${
                activeOrderFilter.includes(OrderStatus.Assigned)
                  ? 'primary'
                  : 'default'
              }`}
              size="xsmall"
            >
              {t(`order.status_${OrderStatus.Assigned}`)}
            </JetButton>
            <JetButton
              value={OrderStatus.Unassigned}
              className={classes.orderFilterButton}
              onClick={() => handleFilterElements(OrderStatus.Unassigned)}
              variation={`${
                activeOrderFilter.includes(OrderStatus.Unassigned)
                  ? 'primary'
                  : 'default'
              }`}
              size="xsmall"
            >
              {t(`order.status_${OrderStatus.Unassigned}`)}
            </JetButton>
            <JetButton
              value={OrderStatus.InDelivery}
              className={classes.orderFilterButton}
              onClick={() => handleFilterElements(OrderStatus.InDelivery)}
              variation={`${
                activeOrderFilter.includes(OrderStatus.InDelivery)
                  ? 'primary'
                  : 'default'
              }`}
              size="xsmall"
            >
              {t(`order.status_${OrderStatus.InDelivery}`)}
            </JetButton>
          </OrderFilterWrapper>
        </Tabs>
      </div>
      {children}
    </>
  );
};

export default OrderFilter;
